import React from "react";
import { withRouter } from "react-router";
import "bootstrap/dist/css/bootstrap.css";

function politicaPrivacidad() {
  return (
    <div className="politica-privacidad-condiciones">
      <p>POLITICA DE PRIVACIDAD</p>
      <p>
        La presente Pol&iacute;tica de Privacidad Social regula el tratamiento
        de los datos personales solicitados/recabados por la sociedad que
        gestiona el establecimiento (en adelante, El Establecimiento).
      </p>
      <p>
        En ella encontrar&aacute;s informaci&oacute;n importante sobre el
        tratamiento de tus datos personales y los derechos que te reconoce la
        normativa. Si tienes dudas o necesitas cualquier aclaraci&oacute;n al
        respecto puedes contactar con nosotros a trav&eacute;s de los canales
        indicados en la misma.
      </p>
      <p>
        El Establecimiento se reserva el derecho de actualizar esta
        Pol&iacute;tica de Privacidad en cualquier momento con motivo de
        decisiones empresariales, as&iacute; como para cumplir con eventuales
        cambios legislativos o jurisprudenciales.
      </p>
      <p>
        Los datos facilitados deben ser verdaderos, exactos, completos y
        actualizados, siendo responsable de cualquier da&ntilde;o o perjuicio,
        directo o indirecto, que pudiera ocasionarse como consecuencia del
        incumplimiento de tal obligaci&oacute;n.
      </p>
      <ol>
        <li>
          &iquest;QUI&Eacute;N ES EL RESPONSABLE DEL TRATAMIENTO DE TUS DATOS
          PERSONALES?
        </li>
      </ol>
      <p>El Responsable del Tratamiento es El Establecimiento.</p>
      <p>
        Createc Interactiva S.L. (B21549969), bajo su marca Wifreezone,
        ser&aacute; Encargado del Tratamiento para cualquier de los tratamientos
        que el Responsable de la informaci&oacute;n haga uso desde las
        herramientas que Wifreezone pone a su disposici&oacute;n.
      </p>
      <ol start="2">
        <li>
          &iquest;CON QU&Eacute; FINALIDADES TRATAMOS TUS DATOS PERSONALES?
        </li>
      </ol>
      <ol>
        <li className="nostyle">
          a)<strong>Ges</strong>
          <strong>ti</strong>
          <strong>&oacute;n integral Registro/Cuenta</strong>: trataremos tus
          datos personales para gestionar el proceso de registro, la
          administraci&oacute;n y gesti&oacute;n de tu cuenta de usuario y la
          relaci&oacute;n con el sistema wifi.
        </li>
      </ol>
      <ol>
        <li className="nostyle">
          b)<strong>Prestaci&oacute;n del servicio: </strong>establecer una
          comunicaci&oacute;n directa con el usuario antes, durante o
          despu&eacute;s de la estancia en el establecimiento, con el objetivo
          de poder prestar el servicio de forma correcta y medir la calidad del
          mismo.
        </li>
      </ol>
      <ol>
        <li className="nostyle">
          c)
          <strong>
            Env&iacute;o de comunicaciones comerciales e informaci&oacute;n de
            inter&eacute;s
          </strong>
          : si en el proceso de registro, acceso al servicio o por alg&uacute;n
          otro medio, lo aceptas expresamente, tus datos se utilizar&aacute;n
          para remitirte comunicaciones comerciales personalizadas, tal y como
          te explicamos en el apartado siguiente.
        </li>
      </ol>
      <ol start="3">
        <li>
          &iquest;PODEMOS TRATAR TUS DATOS PARA REMITIRTE COMUNICACIONES
          COMERCIALES?
        </li>
      </ol>
      <p>
        El Establecimiento desea mantenerte informado de sus productos/servicios
        y remitirte, por medios/canales electr&oacute;nicos o no, ofertas
        comerciales, informaci&oacute;n y publicidad personalizada sobre ellos,
        en base a la informaci&oacute;n personal que nos has facilitado, lo que
        entendemos te resultar&aacute; de mayor inter&eacute;s y
        contribuir&aacute; adem&aacute;s a mejorar tu experiencia de usuario con
        nosotros.
      </p>
      <p>
        Al hacer clic en la casilla "Acepto recibir comunicaciones
        comerciales&rdquo; autorizas el tratamiento de tus datos personales para
        dicha finalidad.
      </p>
      <p>
        Por supuesto podr&aacute;s, en cualquier momento, revocar el
        consentimiento prestado para la recepci&oacute;n de dichas
        comunicaciones comerciales, para lo cual debes remitirnos un correo
        electr&oacute;nico a la direcci&oacute;n electr&oacute;nica
        support@wifreezone.com, indicando como referencia &ldquo;Ejercicio
        Derechos RGPD - Baja comunicaciones comerciales&rdquo;, acreditando tu
        identidad adjuntando copia de tu DNI, pasaporte u otro documento
        v&aacute;lido que te identifique. La revocaci&oacute;n de este
        consentimiento no afectar&aacute; a las otras dos finalidades
        (Gesti&oacute;n integral Registro/Cuenta y Prestaci&oacute;n del
        servicio).
      </p>
      <ol start="3">
        <li>
          &iquest;QU&Eacute; TIPO DE DATOS PERSONALES OBTENEMOS Y TRATAMOS?
        </li>
      </ol>
      <ol>
        <li>
          Informaci&oacute;n enviada: la informaci&oacute;n que ha facilitado
          cuando se ha registrado, tal como la cuenta de redes sociales o
          informaci&oacute;n facilitada en un formulario.
        </li>
        <li>
          Informaci&oacute;n adicional: las respuestas a cualquiera de las
          encuestas que le enviamos. No recopilamos informaci&oacute;n utilizada
          para realizar transacciones financieras.
        </li>
        <li>
          Informaci&oacute;n del dispositivo: la informaci&oacute;n sobre el
          dispositivo (tel&eacute;fono m&oacute;vil, tableta, ordenador
          port&aacute;til, etc&eacute;tera) que utilice.
        </li>
        <li>
          Informaci&oacute;n de red: Recopilamos informaci&oacute;n de su
          dispositivo sobre las direcciones IP, direcciones MAC, tipo de
          navegador, idioma, consumo de ancho de banda, fechas y horas en las
          que se efect&uacute;a la conexi&oacute;n.
        </li>
      </ol>
      <ol start="5">
        <li>
          &iquest;A QU&Eacute; DESTINATARIOS SE COMUNICAR&Aacute;N TUS DATOS?
        </li>
      </ol>
      <p>A ning&uacute;n tercero.</p>
      <ol start="6">
        <li>
          &iquest;CU&Aacute;L ES LA LEGITIMACI&Oacute;N PARA EL TRATAMIENTO DE
          TUS DATOS?
        </li>
      </ol>
      <p>
        La base legal para el tratamiento de tus datos personales es el
        consentimiento que se solicita.
      </p>
      <ol start="7">
        <li>&iquest;POR CU&Aacute;NTO TIEMPO CONSERVAREMOS TUS DATOS?</li>
      </ol>
      <p>
        Los datos se conservar&aacute;n durante un tiempo indefinido hasta que
        el usuario solicite por los medios establecidos la eliminaci&oacute;n de
        sus datos.&nbsp; Siempre se guardar&aacute;n los datos que indique la
        legislaci&oacute;n para &nbsp;&nbsp; &nbsp;(registro de conexiones a
        internet).
      </p>
      <ol start="8">
        <li>
          &iquest;CU&Aacute;LES SON TUS DERECHOS CUANDO NOS FACILITAS SUS DATOS?
        </li>
      </ol>
      <p>Tienes derecho a:</p>
      <p>
        ▪ obtener confirmaci&oacute;n sobre si El Establecimiento est&aacute;
        tratando o no datos personales que te conciernen.
      </p>
      <p>▪ acceder a tus datos personales.</p>
      <p>
        ▪ solicitar la rectificaci&oacute;n de los datos inexactos o que sean
        completados aquellos incompletos.
      </p>
      <p>
        ▪ solicitar su supresi&oacute;n cuando, entre otros motivos, los datos
        ya no sean necesarios para los fines que fueron recogidos.
      </p>
      <p>
        ▪ solicitar, en determinadas circunstancias, la limitaci&oacute;n del
        tratamiento de tus datos, en cuyo caso &uacute;nicamente los
        conservaremos para la formulaci&oacute;n, el ejercicio o la defensa de
        reclamaciones o para la protecci&oacute;n de los derechos de otras
        personas.
      </p>
      <p>
        ▪&nbsp;oponerte, en todo momento, al tratamiento de tus datos con fines
        de mercadotecnia directa, incluida la elaboraci&oacute;n de perfiles
        comerciales. En tal caso dejaremos de tratar tu informaci&oacute;n
        personal para dichos fines.
      </p>
      <p>
        ▪&nbsp;solicitar, en el caso de tratamientos efectuados por medios
        automatizados, la portabilidad de los datos personales que nos hayas
        facilitado, los cuales te ser&aacute;n entregados en un formato
        estructurado, de uso com&uacute;n y legible por m&aacute;quina,
        as&iacute; como a solicitar que se transmitan a otra entidad responsable
        del tratamiento, cuando ello sea t&eacute;cnicamente posible.
      </p>
      <p>
        ▪ revocar tu consentimiento en relaci&oacute;n con uno o varios de los
        tratamientos basados en el mismo, en cuyo caso dejaremos de tratar tu
        informaci&oacute;n personal para dichos fines, sin que ello afecte a la
        licitud del tratamiento basado en el consentimiento previo a su
        retirada.
      </p>
      <p>
        ▪ presentar reclamaciones ante la Agencia Espa&ntilde;ola de
        Protecci&oacute;n de Datos (https://sedeagpd.gob.es). Para ejercitar
        estos derechos debes remitir un correo electr&oacute;nico a
        support@wifreezone.com&nbsp;indicando como referencia &ldquo;Ejercicio
        Derechos RGPD&rdquo;, concretando tu petici&oacute;n y acreditando tu
        identidad (adjuntar copia de tu DNI, pasaporte u otro documento
        v&aacute;lido de identificaci&oacute;n).
      </p>
    </div>
  );
}

export default withRouter(politicaPrivacidad);
